<div class="container mt-2">
  <div *ngIf="!isExamCompleted" class="text-center">

    <div class="py-4" *ngIf="examResult < 80">
      <h3 class="py-3 text-danger">
        {{ translationService.getTranslation('Unfortunately, you did not pass the test') }}
      </h3>
      <img src="assets/logo/fail-exam.png" alt="Fail Logo" style="width: 400px;" />
    </div>

    <div class="fw-bold py-4">
      <h3 class="py-3 text-success">
        {{ translationService.getTranslation('Congratulations! You passed the exam') }}
      </h3>
      <img src="assets/logo/pass-exam.png" alt="Pass Logo" style="width: 400px;" />
      <h5 class="text-muted">{{translationService.getTranslation('Result is considered "Provisional" and awaiting final confirmation')}}</h5>
    </div>

    <button class="btn btn-success w-25" (click)="restartExam()">{{ translationService.getTranslation('Back') }}</button>
  </div>

  <div *ngIf="isExamCompleted" class="py-3">

    <div class="d-flex justify-content-between mb-2">
      <div>
        <h2>{{ selectedFolderName }} - {{ translationService.getTranslation('Start Exam') }}</h2>
        <h6>{{ translationService.getTranslation('Candidte Name') }}: {{ traineeName }}</h6>
        <h6>{{ translationService.getTranslation('ID') }}: {{ IDNumber }}</h6>
        <h6>{{ translationService.getTranslation('Exam Attendance Number') }}: {{ ExamAttendanceNo }}</h6>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <div class="border border-3 border-success text-success rounded-circle text-center p-4 fs-5 fw-bold">
          {{ formatTime(remainingTime) }}
        </div>
      </div>
     </div>

    <div class="card" [dir]="isRTL ? 'rtl' : 'ltr'">
      <div class="card-body">
        <div *ngIf="AnswersDto?.length > 0" class="progress-container mb-3">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                 role="progressbar" 
                 [style.width.%]="progressPercentage"
                 aria-valuenow="{{ progressPercentage }}" 
                 aria-valuemin="0" 
                 aria-valuemax="100">
            </div>
          </div>
        </div>
        
        
        <div class="d-flex align-items-center mb-4">
          <h4 class="me-2 mb-0 flex-grow-1 mainQustion">
            <span>{{ currentQuestionIndex+1 }}</span> - {{ currentQuestionText }}
            <i class="bi bi-volume-up text-success mx-2" role="button" 
               (click)="playAudio(currentQuestionText, LanguageID)" 
               style="cursor: pointer; font-size: 1.5rem;">
            </i>
          </h4>
          <div
            class="border border-3 rounded-circle text-center p-4 fs-5 fw-bold"
            [ngClass]="{
              'text-success': remainingTimePerQuestion >= 20,
              'border-success': remainingTimePerQuestion >= 20,
              'text-danger': remainingTimePerQuestion < 20,
              'border-danger': remainingTimePerQuestion < 20
            }">
            {{ formatTime(remainingTimePerQuestion) }}
          </div>
        </div>
        
        
        
        
        <div *ngIf="QuestionContent && (QuestionContent.ImageLink || QuestionContent.VideoLink)" class="mb-3">
          <div *ngIf="QuestionContent.ImageLink" class="text-center">
            <img [src]="getImageLink + QuestionContent.ImageLink" class="img-thumbnail w-75" />
          </div>
          <div *ngIf="QuestionContent.VideoLink" class="text-center">
            <video *ngIf="currentQuestionIndex" id="questionVideo" controls class="img-thumbnail w-75">
              <source [src]="getVideoLink + QuestionContent.VideoLink + '?t=' + currentQuestionIndex" type="video/mp4" />
            </video>
          </div>                                                    
        </div>
        
        
        <div *ngIf="QuestionContent && (['TF', 'MCQ', 'MCQImages', 'RightOrWrongImage', 'RightOrWrongVideo'].includes(QuestionContent.QuestionType))">
          <div *ngFor="let answer of AnswersDto; let i = index" class="mb-3 d-flex align-items-center">
            <div class="answer-container d-flex align-items-center mb-2">
              <button 
                class="btn w-100 text-start btn-outline-success me-2" 
                [class.btn-success]="selectedAnswer === answer.AnswerID"
                [class.text-light]="selectedAnswer === answer.AnswerID"
                (click)="selectAnswer(answer.AnswerID)">
                
                <div *ngIf="QuestionContent.QuestionType !== 'MCQImages'">
                  <span>{{ answer.AnswerText }}</span>
                </div>
            
                <div *ngIf="QuestionContent.QuestionType === 'MCQImages'" class="text-center">
                  <div 
                    class="img-thumbnail mx-auto d-flex justify-content-center align-items-center"
                    [ngStyle]="{
                      'background-image': 'url(' + getImageLink + answer.ImageLink + ')',
                      'background-size': 'cover',
                      'background-position': 'center',
                      'width': '180px',
                      'height': '180px',
                    }"
                    (contextmenu)="$event.preventDefault()">
                  </div>
                  <div class="pt-1 fw-bold">  
                    <span>{{ answer.AnswerText }}</span>
                  </div>
                </div>
              </button>
              <i
                class="bi bi-volume-up text-success mx-2" 
                role="button" 
                (click)="playAudio(answer.AnswerText, LanguageID)" 
                style="cursor: pointer; font-size: 1.5rem;">
              </i>
            </div>
          </div>
                        
          <div class="my-3" [dir]="!isRTL ? 'rtl' : 'ltr'">
              <button class="btn btn-outline-success fw-bold btn-lg" 
              [disabled]="selectedAnswer == null" 
              (click)="goToNextQuestion()">
              {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
            </button>
          </div>
        </div>
        

        <div *ngIf="QuestionContent && (QuestionContent.QuestionType === 'MultiAnswers')">
          <div *ngFor="let answer of AnswersDto; let i = index" class="mb-3 d-flex align-items-center">
            <div class="answer-container d-flex align-items-center mb-2">
              <button 
                class="btn w-100 text-start btn-outline-success" 
                [class.btn-success]="selectedAnswers.includes(answer.AnswerID)"
                [class.text-light]="selectedAnswers.includes(answer.AnswerID)"
                (click)="selectAnswer(answer.AnswerID, 'MultiAnswers')">
                {{ answer.AnswerText }}
              </button>
              <i class="bi bi-volume-up text-success mx-2" 
                role="button" 
                (click)="playAudio(answer.AnswerText, LanguageID)" 
                style="cursor: pointer; font-size: 1.5rem;">
              </i>
            </div>
          </div>

          <div class="my-3" [dir]="!isRTL ? 'rtl' : 'ltr'">
              <button class="btn btn-outline-success fw-bold btn-lg" 
              [disabled]="selectedAnswers.length < 1" 
              (click)="goToNextQuestion()">
              {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
            </button>
          </div>
        </div>


        <div *ngIf="QuestionContent && (QuestionContent.QuestionType === 'Ordering')">
          <div cdkDropListGroup>
            <div class="row">

              <div class="col-md-6">
                <div class="bg-light p-3 border rounded">
                  <p class="text-success fw-bold text-center">{{ translationService.getTranslation('Drag and arrange the steps into the square on the left') }}
                    <i class="bi bi-volume-up text-success me-2" role="button" 
                      (click)="playAudio(translationService.getTranslation('Drag and arrange the steps into the square on the left'), LanguageID)" 
                      style="cursor: pointer; font-size: 1rem;">
                    </i>
                  </p>
                  <div cdkDropList [cdkDropListData]="AnswersDto" (cdkDropListDropped)="drop($event)">
                    <div *ngFor="let answer of AnswersDto; trackBy: trackItem" class="border border-2 border-success text-center p-2 mb-2" cdkDrag>
                      {{ answer.AnswerText }}
                      <i class="bi bi-volume-up text-success me-2" role="button" (click)="playAudio(answer.AnswerText, LanguageID)" style="cursor: pointer; font-size: 1rem;">
                    </i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="bg-light p-3 border rounded">
              
                  <div cdkDropList [cdkDropListData]="selectedAnswers" (cdkDropListDropped)="drop($event)">
                    <div class="d-flex justify-content-between text-cealign-items-center mb-2">
                      <p class="text-success fw-bold">{{ translationService.getTranslation('Arrange the answers in the correct sequence') }}
                        <i class="bi bi-volume-up text-success me-2" role="button" 
                        (click)="playAudio(translationService.getTranslation('Arrange the answers in the correct sequence'), LanguageID)" 
                        style="cursor: pointer; font-size: 1rem;">
                      </i>
                      </p>
                      <button class="btn btn-outline-danger btn-sm" (click)="resetOrdering()">
                        {{translationService.getTranslation('Resest')}}<i class="bi bi-arrow-clockwise mx-1"></i>
                      </button>
                    </div>
                    
              
                    <div *ngFor="let item of selectedAnswers; let i = index; trackBy: trackItem" class="d-flex align-items-center mb-2" cdkDrag>
                      <div class="me-3 bg-secndary text-success text-center p-2 rounded fs-5 fw-bold">
                        {{ i + 1 }}
                      </div>
                      <div
                        class="d-inline-block border border-2 bg-success text-white text-center p-2"
                        cdkDropList
                        [cdkDropListData]="item.AnswerText"
                        (cdkDropListDropped)="drop($event, i)">
                        {{ item.AnswerText }}
                        <i class="bi bi-volume-up text-white me-2" 
                           role="button" 
                           (click)="playAudio(item.AnswerText, LanguageID)" 
                           style="cursor: pointer; font-size: 1rem;">
                        </i>
                      </div>
                    </div>
                  </div>
              
                </div>
              </div>              
            </div>
          </div>
          
          <div class="my-3" [dir]="!isRTL ? 'rtl' : 'ltr'">
              <button class="btn btn-outline-success fw-bold btn-lg" 
              [disabled]="AnswersDto.length > 0" 
              (click)="goToNextQuestion()">
              {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
            </button>
          </div>
        </div>
        
      <div class="mt-5 d-flex justify-content-between" [dir]="!isRTL ? 'rtl' : 'ltr'">
        <button class="btn btn-outline-warning me-2" (click)="skipQuestion()" [disabled]="skipCount === 0">
          {{ translationService.getTranslation('Skip The Question') }} ( {{skipCount}} {{ translationService.getTranslation('Remaining') }} )
        </button>
        <button class="btn btn-outline-info" (click)="postponeQuestion()" [disabled]="postponeCount === 0">
          {{ translationService.getTranslation('Postpone The Question') }} ( {{postponeCount}} {{ translationService.getTranslation('Remaining') }} )
        </button>
      </div>

    </div>
  </div>
</div>
</div>
